<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<template>
  <div :class="['page', { isMobile: true }]">
    <BaseProgressBar class="base-progress-bar" :limit="6" :progress="6" />
    <div class="container">
      <div>
        <span>Uploading your Check-In...</span>
        <BaseLoadingSpinner />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable no-descending-specificity
// stylelint-disable selector-pseudo-element-no-unknown

.page {
  margin: auto;
  position: relative;
  width: 400px;
  @media screen and (max-width: 900px) {
    width: 100%;
  }

  .container {
    background: white;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    height: 65vh;
    justify-content: space-between;
    margin-top: 56px;
    max-height: 70rem;
    overflow: auto;
    position: relative;
    width: 100%;
    div {
      margin: auto;
      span {
        font-size: 25px;
        font-weight: 800;
        width: 100%;
      }
      ::v-deep .loading {
        height: 5rem;
        margin-top: 50px;
        width: 5rem;
      }
    }
  }
  &.isMobile {
    height: 100%;
    padding-top: 40px;
    width: 100%;
    .base-progress-bar {
      margin-left: 6.4%;
      width: 87.2%;
    }
  }
}
</style>
